var link_viewer_default = {
  "fontElementMap": "dDLTA",
  "link": "aTHQT",
  "linkInEditor": "Jk1hT",
  "linkInViewer": "Cywxl",
  "toolbarUrlContainer": "_9WJ6h",
  "toolbarUrl": "K3V8l",
  "toolbarUrlAnchor": "NpkG7"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
